import axios from "axios";

export class ServiceTranslationController {
  async downloadTranslationFiles(): Promise<string> {
    const response = await axios.post('/api/organizations/superadmin/translation/downloadFiles');
    return response.data.processId;
  }

  async getProcessStatus(processId: string): Promise<{ status: string, message: string }> {
    const response = await axios.get(`/api/organizations/superadmin/translation/process/${processId}`);
    return response.data;
  }

  async getLatestVersionNumber(): Promise<number> {
    const response = await axios.get('/api/organizations/superadmin/translation/latestVersionNumber');
    return response.data.versionNumber;
  }
}

export const ServiceTranslation = new ServiceTranslationController(); 